import { AlertCircle, CheckCircle2, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/Sections';

export function PaymentStatus({ status }) {
  const successfulReturn = status === 'return';
  return (
    <>
      <PageHero
        eyebrow="Payment status"
        title={successfulReturn ? 'Your payment provider has returned you to Sawwari.' : 'The payment was cancelled or not completed.'}
        text={successfulReturn
          ? 'A browser return does not by itself confirm payment. Sawwari verifies the signed provider response and server-side transaction record before updating a fare or wallet.'
          : 'No successful payment is assumed. Check the app transaction history before trying again, because a provider may still be reconciling the attempt.'}
        tone={successfulReturn ? 'mint' : 'light'}
      />
      <section className="section">
        <div className="container payment-status-card">
          {successfulReturn ? <CheckCircle2 /> : <AlertCircle />}
          <h2>{successfulReturn ? 'Verification in progress' : 'Payment not confirmed'}</h2>
          <p>Do not share your OTP, PIN, password or full account credentials with Sawwari support. Keep the journey and provider transaction references if you need assistance.</p>
          <div className="legal-priority-note"><ShieldCheck /><p>Only the Sawwari backend and payment-provider reconciliation may mark a transaction successful. Query-string values shown in a browser are never treated as proof of payment.</p></div>
          <div className="button-row">
            <Link className="button button--primary" to="/support">Get payment support</Link>
            <Link className="button button--secondary" to="/fares-cancellations-refunds">Read refund rules</Link>
          </div>
        </div>
      </section>
    </>
  );
}
